import { combineReducers } from "redux";

import {data} from './reducers/dataReducer'
//import {pages} from './reducers/pageReducer'
export default combineReducers({
  data
})
